import { Button } from 'components/buttons/Button/Button';
import './styles.scss';
// [
//     {
//         title: 'New catalog name',
//         type: 'catalog',
//         image: 'http://54.93.104.183/storage/form-sidebar-picture.jpg',
//         description: 'New catalog Description',
//         file: 'http://54.93.104.183/storage/js cheatsheet.pdf',
//         flyers: [],
//     },
// ];
const ProductCatalogBox = ({ title, image, description, file }) => {
    return (
        <div className="box product-box">
            <h3>{title}</h3>
            <div className="product-catalog">
                <img src={image} alt="wuxal catalog" />
                <p className="body1 product-catalog__text">{description}</p>
                <div className="product-catalog__buttons">
                    <a
                        href={file}
                        rel="noopener noreferrer"
                        target="_blank"
                        className="button button-eye  has-children"
                    >
                        <div></div>
                        <div>VIEW CATALOG</div>
                    </a>
                    <a
                        href={file}
                        rel="noopener noreferrer"
                        target="_blank"
                        className="button download-button has-children"
                    >
                        <div></div>
                        <div>DOWNLOAD</div>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default ProductCatalogBox;
